import { useMemo, useState, type FC } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { VendorMessageSubSection } from "@b2bportal/ground-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { VendorMessage } from "@tenant/cars";
import clsx from "clsx";
import defaultStyles from "./ExpandableVendorMessage.module.scss";

export interface ExpandableVendorMessageProps {
  vendorMessages: VendorMessageSubSection[];
  initialAmount: number;
  className?: string;
}

const ComponentName = "ExpandableVendorMessage";

export const ExpandableVendorMessage: FC<ExpandableVendorMessageProps> = ({
  vendorMessages,
  initialAmount,
  className,
}) => {
  const [block, cn] = useModuleBEM(defaultStyles, ComponentName);
  const { t } = useI18nContext();

  const [displayAllMessages, setDisplayAllMessages] = useState(false);

  const { initialMessages, remainingMessages } = useMemo(() => {
    return {
      initialMessages: vendorMessages.slice(0, initialAmount),
      remainingMessages: vendorMessages.slice(initialAmount),
    };
  }, [vendorMessages, initialAmount]);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("content")}>
        {initialMessages.map((message, idx) => (
          <VendorMessage key={`${message.title}-${idx}`} message={message} />
        ))}

        {displayAllMessages
          ? remainingMessages.map((message, idx) => (
              <VendorMessage
                key={`${message.title}-${idx}`}
                message={message}
              />
            ))
          : null}

        {!displayAllMessages && remainingMessages.length > 0 ? (
          <button
            type="button"
            className={cn("expand-cta")}
            onClick={() => setDisplayAllMessages(true)}
          >
            {t("vendorMessages.expandAll")}
          </button>
        ) : null}
      </div>
    </div>
  );
};
